var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNordicMagnifyingGlassDarkyellowbrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(-1654.928 -1041.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(1654.928 1041.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M23.286,23.285a1.533,1.533,0,0,1,2.169,0l5.9,5.9a1.533,1.533,0,1,1-2.167,2.169l-5.9-5.9a1.533,1.533,0,0,1,0-2.169Z",
    transform: "translate(-7.804 -6.802)",
    fill: "#7d6630",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M9.962,18.391A8.429,8.429,0,1,0,1.533,9.962,8.429,8.429,0,0,0,9.962,18.391Zm9.962-8.429A9.962,9.962,0,1,1,9.962,0,9.962,9.962,0,0,1,19.923,9.962Z",
    fill: "#7d6630",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicMagnifyingGlassDarkyellowbrown);
export default __webpack_public_path__ + "static/media/nordic_magnifying_glass_darkyellowbrown.86619c49fec511ac102534bab2f429a8.svg";
export { ForwardRef as ReactComponent };